import { render } from "./vue-friendlycaptcha.vue?vue&type=template&id=0f8281b4"
import script from "./vue-friendlycaptcha.vue?vue&type=script&lang=ts"
export * from "./vue-friendlycaptcha.vue?vue&type=script&lang=ts"
script.render = render

export default script